import { render, staticRenderFns } from "./LoteMaiorDesconto.vue?vue&type=template&id=17c80934"
import script from "./LoteMaiorDesconto.vue?vue&type=script&lang=js"
export * from "./LoteMaiorDesconto.vue?vue&type=script&lang=js"
import style0 from "./LoteMaiorDesconto.vue?vue&type=style&index=0&id=17c80934&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports